import compareAsc from 'date-fns/compareAsc';
import format from 'date-fns/format';
import { generateTitle } from 'utils/charts/common';
import {
    noResultsText,
    PERCENT_OF_EXECUTION_ONLY_TRADES,
    TREND_ANALYSIS_TITLE
} from 'utils/charts/constants';
import { generateTrendAnalysisYAxisMin } from 'utils/charts/chart';

export const scenarioThreeTrendAnalysisChartOptions = (trendData) => {
    const formattedData =
        trendData &&
        trendData
            .filter((item) => typeof item.percentEo === 'number')
            .sort((a, b) =>
                compareAsc(
                    new Date(a.year, a.month - 1),
                    new Date(b.year, b.month - 1)
                )
            )
            .reduce(
                (acc, curr) => [
                    ...acc,
                    [
                        format(new Date(curr.year, curr.month - 1), 'MMM-yy'),
                        curr.percentEo
                    ]
                ],
                []
            );
    const dateList = formattedData && formattedData.map((item) => item[0]);
    const valueList = formattedData && formattedData.map((item) => item[1]);
    return {
        title: generateTitle(TREND_ANALYSIS_TITLE),
        xAxis: [
            {
                data: dateList ? dateList : [],
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: true,
                    padding: [16, 0, 0, 0]
                }
            }
        ],
        yAxis: [
            {
                name: PERCENT_OF_EXECUTION_ONLY_TRADES,
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                nameGap: 60,
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                min: generateTrendAnalysisYAxisMin(valueList)
            }
        ],
        series: [
            {
                type: 'line',
                symbolSize: [7, 7],
                data: valueList
                    ? valueList.map((value) => value.toFixed(2))
                    : [],
                lineStyle: {
                    color: '#929292'
                },
                itemStyle: {
                    color: '#929292'
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 10,
                    fontWeight: 700,
                    lineheight: 14,
                    offset: [0, -4],
                    formatter: '{c}%'
                },
                cursor: 'default'
            }
        ],
        grid: {
            width: '400px',
            height: '60%',
            top: '20%',
            left: '15%'
        },
        graphic: !dateList || dateList.length === 0 ? [noResultsText] : []
    };
};
